<template>
  <div class="child-zone-box" v-show="visible" :style="boxStyle">
    <div class="box-header" @mousedown="handleMouseDown">
      <span class="box-header--content">
        <span v-if="currentZoneName" style="color: #0890f2;">({{ currentZoneName }})</span>
        子片区详情
      </span>
      <span class="box-header--close" @mousedown.stop @click.stop="closeBox">×</span>
    </div>
    <div class="box-header-bottom">
      <span style="margin-left: 16px; font-size: 18px; color: #333; font-weight: 600;">{{ levelCountsText }}</span>
    </div>
    <a-spin :spinning="loading">
      <div class="box-content">
        <a-table class="child-zone-table" :columns="columns" :data-source="tableData" :pagination="false" bordered
          row-key="zoneId" :scroll="{ y: 250 }">
          <template slot="operation" slot-scope="text, record">
            <a v-if="record.hasSubZones" @click="handleViewSubordinate(record)" class="operation-link">
              查看下级
            </a>
            <span v-else style="color: #ccc; cursor: not-allowed;">查看下级</span>
          </template>
        </a-table>
      </div>
    </a-spin>
    <div class="box-footer">
      <a-button type="primary" @click="handleExport">导出</a-button>
      <a-button v-if="historyStack.length > 0" style="margin-left: 10px;" @click="handleBack">返回</a-button>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { Button } from 'ant-design-vue'

export default {
  name: 'ChildZoneBox',
  components: {
    'a-button': Button
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    zoneId: {
      type: String,
      default: ''
    },
    zoneName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      hasDragged: false,
      position: {
        x: null,
        y: null
      },
      isDragging: false,
      loading: false,
      dragStart: {
        x: 0,
        y: 0
      },
      columns: [
        {
          title: '片区名称',
          dataIndex: 'zoneName',
          key: 'zoneName',
          align: 'center',
          ellipsis: true,
        },
        {
          title: '昨天供水量',
          dataIndex: 'yesterdaySupply',
          key: 'yesterdaySupply',
          align: 'center'
        },
        {
          title: '昨天售水量',
          dataIndex: 'yesterdaySales',
          key: 'yesterdaySales',
          align: 'center'
        },
        {
          title: '产销差率',
          dataIndex: 'leakageRate',
          key: 'leakageRate',
          align: 'center'
        },
        {
          title: '操作',
          key: 'operation',
          align: 'center',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      tableData: [],
      levelCounts: {},
      historyStack: [], // 历史记录栈
      currentZoneId: '', // 当前显示的zoneId
      currentZoneName: '' // 当前显示的zoneName
    }
  },
  computed: {
    boxStyle () {
      if (this.hasDragged && this.position.x !== null && this.position.y !== null) {
        return {
          left: this.position.x + 'px',
          top: this.position.y + 'px',
          right: 'auto'
        }
      }
      return {
        top: '1%',
        right: '280px'
      }
    },
    levelCountsText () {
      if (!this.levelCounts || Object.keys(this.levelCounts).length === 0) {
        return ''
      }
      // 将对象转换为数组并排序
      const sortedLevels = Object.keys(this.levelCounts).sort()
      return sortedLevels.map(level => `${level}分区:     ${this.levelCounts[level]}个`).join('  ')
    }
  },
  watch: {
    visible (newVal) {
      if (newVal === true) {
        console.log('ChildZoneBox visible 为 true，zoneId:', this.zoneId)
        this.currentZoneId = this.zoneId
        this.currentZoneName = this.zoneName
        this.historyStack = [] // 清空历史记录
        this.getData()
      }
    },
    zoneId (newVal) {
      if (this.visible) {
        this.currentZoneId = newVal
        this.currentZoneName = this.zoneName
        // 注意：如果外部改变了 zoneId，可能意味着重置，这里视情况是否清空历史
        // 考虑到通常是点击了新的片区，这里选择不强制清空历史，或者让 visible 的 watcher 去处理
      }
    }
  },
  mounted () {
    // 监听全局鼠标事件
    document.addEventListener('mousemove', this.handleMouseMove)
    document.addEventListener('mouseup', this.handleMouseUp)
  },
  beforeDestroy () {
    // 移除全局事件监听
    document.removeEventListener('mousemove', this.handleMouseMove)
    document.removeEventListener('mouseup', this.handleMouseUp)
  },
  methods: {
    closeBox () {
      this.$emit('close')
    },
    handleMouseDown (e) {
      // 如果是第一次拖拽，获取当前元素的位置
      if (!this.hasDragged) {
        const rect = this.$el.getBoundingClientRect()
        this.position.x = rect.left
        this.position.y = rect.top
        this.hasDragged = true
      }

      // 计算拖拽起始位置
      this.dragStart.x = e.clientX - this.position.x
      this.dragStart.y = e.clientY - this.position.y

      this.isDragging = true
      e.preventDefault()
    },
    handleMouseMove (e) {
      if (this.isDragging && this.hasDragged && this.position.x !== null && this.position.y !== null) {
        let newX = e.clientX - this.dragStart.x
        let newY = e.clientY - this.dragStart.y

        // 限制在可视区域内
        const maxX = window.innerWidth
        const maxY = window.innerHeight
        newX = Math.max(0, Math.min(newX, maxX))
        newY = Math.max(0, Math.min(newY, maxY))

        this.position.x = newX
        this.position.y = newY
      }
    },
    handleMouseUp () {
      this.isDragging = false
    },
    handleViewSubordinate (record) {
      console.log('查看下级:', record)
      // 记录当前状态到历史栈
      this.historyStack.push({
        zoneId: this.currentZoneId,
        zoneName: this.currentZoneName
      })
      // 更新为下级状态
      this.currentZoneId = record.zoneId
      this.currentZoneName = record.zoneName
      this.getData()
    },
    handleBack () {
      // 出栈
      const prev = this.historyStack.pop()
      if (prev) {
        this.currentZoneId = prev.zoneId
        this.currentZoneName = prev.zoneName
        this.getData()
      }
    },
    handleExport () {
      console.log('导出数据')
      this.loading = true
      axios.get(`${process.env.VUE_APP_API_BASE_URL}zone-metering/data-analyse/sub-zones/${this.currentZoneId}/export`, {
        responseType: 'blob',
        headers: {
          'Authorization': storage.get(ACCESS_TOKEN),
          'Accept': 'application/vnd.ms-excel'
        }
      }).then((res) => {
        const blob = new Blob([res.data])
        const fileName = this.currentZoneName + '子片区详情.xlsx'
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        window.URL.revokeObjectURL(link.href)
      }).finally(() => {
        this.loading = false
      })
    },
    getData () {
      this.loading = true
      this.$http.get(`/zone-metering/data-analyse/sub-zones/${this.currentZoneId}`).then(({ data }) => {
        this.tableData = data.subZones
        this.levelCounts = data.levelCounts
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="less" scoped>
.child-zone-box {
  position: fixed !important;
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  z-index: 99999 !important;
  width: 600px;
  height: 500px;
  display: flex;
  flex-direction: column;
  isolation: isolate;

  .box-header {
    background: #ffffff;
    border-radius: 8px 8px 0 0;
    display: flex;
    height: 46px;
    align-items: center;
    padding: 12px 16px 0 16px;
    cursor: move;
    user-select: none;
    margin-bottom: 20px;

    .box-header--content {
      flex: 1;
      font-size: 18px;
      color: #000000;
      font-weight: 600;
    }

    .box-header--close {
      font-size: 28px;
      color: #666666;
      cursor: pointer;
      line-height: 1;
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: color 0.3s;
      text-decoration: none;
      cursor: default; // 防止拖动时显示移动光标

      &:hover {
        color: #000000;
        text-decoration: none;
      }
    }
  }

  .box-header-bottom {
    margin: 0px 16px;
    height: 50px;
    background-color: #f9f9f9;
    display: flex;
    align-items: center;
  }

  .box-content {
    flex: 1;
    padding: 16px;
    overflow: auto;

    .operation-link {
      color: #0890f2;
      cursor: pointer;

      &:hover {
        color: #078ee7;
        text-decoration: underline;
      }
    }
  }

  ::v-deep .child-zone-table {
    .ant-table-thead>tr>th {
      background-color: #f6f6f6 !important;
    }
  }

  .box-footer {
    padding: 16px;
    display: flex;
    justify-content: flex-start;
  }
}
</style>